import { Badge, Box, Flex, Skeleton, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

type Props = {
  title: string;
  displayDate: string;
  status: string;
  orderId?: string;
  rightExtra?: ReactNode;
  createdByUserId?: string;
  cachedCustomer?: any;
  customerDisplayName?: string;
};

export default function ChatHeader({ title, displayDate, status, orderId, rightExtra, createdByUserId , cachedCustomer, customerDisplayName}: Props) {
  const isClosed = status === "Closed"
  return (
    <Flex align="flex-start" justify="space-between" gap="12px" mb="24px" pb="16px"  borderBottom="1px solid #E6ECF3">
      <Box>
        <Text fontSize="16px" fontWeight="600" lineHeight="1" color="#0B0E10" mb="10px">
         {orderId && orderId !== "0" ? "Order #" + orderId + " - " : ""}{title}
        </Text>

        {createdByUserId != null && (
              <Skeleton isLoaded={!!cachedCustomer} w="200px" h="20px" borderRadius="4px" mb="4px">
                <Text fontSize="14px" fontWeight="500" color="#505E70">
                  Customer: {customerDisplayName ?? "—"}
                </Text>
              </Skeleton>
        )}
        
        {displayDate ? (
          <Text fontSize="12px" color="#0B0E10">
            {displayDate}
          </Text>
        ) : null}
      </Box>
      {rightExtra ?? (
        <Badge
          h="32px"
          px="8px"
          py="7px"
          w="52px"
          borderRadius="8px"
          fontSize="14px"
          fontWeight="400"
          bg={isClosed ? "#9CA3AF" : "#BFD7FF"}
          color={isClosed ? "#FFF" : "#0B0E10"}
          display="flex"
          alignItems="center"
          justifyContent="center"
          textTransform="none"
          flexShrink={0}
        >
          {status}
        </Badge>
      )}
    </Flex>
  );
}
